import { formatDateTimeWith } from '../../lib/base-i18n';

/**
 * 워크스페이스의 날짜＋시각 — ⭐ **세 벌이던 것을 한 벌로** (2026-10-06 · 판 ⓑ).
 *
 * ## ⛔ 무엇이 문제였나
 *
 * 같은 식이 **세 파일에 똑같이** 있었다:
 * ```
 * WorkspaceDetailPanel.tsx:50 · WorkspaceDocPanel.tsx:60 · WorkspaceTable.tsx:57
 *   d.toLocaleString(getDateLocale(), {
 *     year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
 *   })
 * ```
 * ⇒ ⛔ 세 벌이면 ★ 이런 고침이 ⭐ **한둘만** 간다 — 그러면 **같은 뜻을 다른 글자로** 보이게 된다.
 * ⇒ ⚠ 실제로 2026-10-06 의 「자정을 오전 0시로」가 ★ 그 셋을 **놓칠 뻔했다**(거르개가 옵션 붙은
 *   꼴을 안 잡았다 — 관제와 디자인이 **둘 다** 놓쳤고 합쳐서 찾았다).
 *
 * ## ★ 보이는 꼴은 **안 바뀐다** — 자정만 바뀐다
 *
 * ```
 *        전                          후
 * 자정   2026. 01. 05. 오전 12:00    ⇒ 2026. 01. 05. ⭐ 오전 0:00
 * 그 밖  2026. 01. 05. 오후 02:03    ⇒ ★ «그대로»
 * ```
 * ⇒ ⛔ `formatDateTime` 으로 **갈아타지 않았다** — 그러면 「2026. 1. 5. 오후 2:03:07」이 되어
 *   ★ 월·일이 한 자리가 되고 ⭐ **초가 생긴다**(= 자정 고침이 아니라 «포맷 변경»이다).
 */
const WORKSPACE_DATETIME_OPTS: Intl.DateTimeFormatOptions = {
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
};

export function formatWorkspaceDateTime(
  iso: string | number | Date | null | undefined,
  fallback = '',
): string {
  return formatDateTimeWith(iso, WORKSPACE_DATETIME_OPTS, fallback);
}
